const initialState = {
    posts: undefined,
    allPosts: [],
    loading: false
  };
export const getPagesReducer = (state = false, action) => {
    switch(action.type){
        case 'GET_PAGES':
            return{
                ...state,
                pages: action.payload,
            }
        case 'DELETE_PAGES':
            return{
                ...state,
                pages: action.payload,
            }
        default:
            return{
                ...state
            }
    }
}
export const getMetaTagsReducer = (state = {}, action) => {
    switch(action.type){
        case 'GET_META_TAGS':
            return{
                ...state,
                meta_tags: action.payload,
                loading: false
            }
        case 'LOADING_META_TAGS':
            return{
                ...state,
                loading: true
            }
        default:
            return{
                ...state
            }
    }
}

export const getSocialPosts = (state = initialState, action) => {
    switch(action.type){
        case 'GET_SOCIAL_POSTS':
            return{
                ...state,
                posts: action.payload.data,
                allPosts: action.payload.data,
                loading: false
            }
        case 'CLEAR_SOCIAL_POSTS':
            return{
                ...state,
                loading: true,
            }
        case 'FILTER_POSTS_BY_STATUS':
            return{
                ...state,
                posts: state.allPosts.filter(post => post.status === action.payload)
            }
        default:
            return{
                ...state
            }
    }
}
export const getFacebookAccounts = (state = {}, action) => {
    switch(action.type){
        case 'GET_FACEBOOK_ACCOUNTS':
            return{
                ...state,
                accounts: action.payload
            }
        default:    
            return{
                ...state
            }
    }
}